import React from "react";
import { Tabs } from "antd";

const XMLFeedGenerationTabUi = ({ tabId, setTabId }) => {
  return (
    <Tabs
      className="mx-2 text-base"
      popupClassName="mb-0"
      tabBarStyle={{
        marginBottom: 0,
      }}
      activeKey={tabId}
      defaultActiveKey={tabId}
      items={[
        { label: "Feeds", key: "feeds" },
        { label: "Additional Settings", key: "additionalSettings" },
      ]}
      onChange={(value) => {
        setTabId(value);
      }}
    />
  );
};

export default XMLFeedGenerationTabUi;
